import clsx from "clsx";
import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { DotConnectorIcon } from "@assets/icons";

const AnnouncementMarquee = forwardRef(function AnnouncementMarquee({
    text = "Announcement text here",
    label = "Announcement",
    articleLink,
    articleLabel,
    dataLink,
    dataLabel = "View Data",
    className,
}, ref) {
    return (
        <div ref={ref} className={clsx(parentContainerStyle, className)}>
            <div className={contentContainerStyle}>
                <div className="flex items-center">
                    <div className="mr-4 text-lg font-bold tracking-wide">
                        {label}
                    </div>
                    <div className={clsx(bodyTextStyle, "mr-4")}>
                        {text}
                    </div>
                    {articleLink && articleLabel && (
                        <>
                            <Link 
                                to={articleLink}
                                className={clsx(linkStyle, "mr-4")}
                            >
                                {articleLabel}
                            </Link>
                            <DotConnectorIcon />
                        </>
                    )}
                    {dataLink && dataLabel && (
                        <>
                            <Link 
                                to={dataLink}
                                className={clsx(linkStyle, "ml-2")}
                            >
                                {dataLabel}
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
});

const contentContainerStyle = clsx(
    "flex w-full items-center justify-center px-4 md:py-2 py-4",
);
const bodyTextStyle = clsx("font-bold tracking-wide text-sm");
const linkStyle = clsx(bodyTextStyle, "underline hover:no-underline text-sm");
const parentContainerStyle = clsx(
    "fixed top-0 left-0 right-0 z-[60] flex bg-blue uppercase text-[black]",
);

export default AnnouncementMarquee;